const getActionsForType = (commentType) => {
  const singular = commentType === 'question' ? 'QUESTION' : 'CHAT_MESSAGE'
  const plural = commentType === 'question' ? 'QUESTIONS' : 'CHAT'

  return [
    [
      `INIT_${plural}`,
      'liveId',
      'presenterToken',
      'includeBotGreeting',
      'doNotFetchQuestions',
    ],
    `FETCH_${plural}_SUCCESS`,
    `FETCH_${plural}_FAILURE`,
    `FETCH_SINGLE_${singular}_SUCCESS`,
    [`DELETE_${singular}`, 'commentId'],
    [`ADD_${singular}`, 'values', 'formSubmitPromise'],
    `ADD_${singular}_SUCCESS`,
    `ADD_${singular}_FAILURE`,
    `RESET_${plural}`,
    `RESET_ADD_${singular}_BUTTON_STATE`,
    `INFINITE_LOAD_${plural}`,
    `INFINITE_LOAD_${plural}_SUCCESS`,
    `INFINITE_LOAD_${plural}_FAILURE`,
    `REALTIME_ADD_${singular}`,
    `OPTIMISTICALLY_ADD_${singular}`,
    `LEAVE_${plural}`,
    `WATCH_REALTIME_${plural}`,
    [`MOVE_${singular}_COMMENT`, 'fromIndex', 'toIndex'],
    [`OPTIMISTICALLY_UPDATE_${singular}_COMMENTS`, 'comments'],
    [`UPDATE_${singular}_COMMENT`, 'commentId', 'status'],
  ]
}

export default [
  ...getActionsForType('question'),
  ...getActionsForType('chat'),
  'REALTIME_DATA_UPDATE',
  'REALTIME_REMOVE_COMMENT',
  'RESET_SCROLLING_PROPS',
  ['ADD_CHAT_REACTION', 'reaction'],
  ['SET_SHOULD_SCROLL', 'shouldScroll'],
  ['SET_SCROLLING_INTENTION', 'scrollIntention'],
]
